<div class="flex justify-end p-1 mb-2">
    <button type="button" (click)="toggleModal.emit()" class="text-primary font-semibold text-4xl flex">
        <ng-icon class="text-blue" size="25" name="faSolidXmark"></ng-icon>
    </button>
</div>

<div class="flex flex-wrap lg:flex-row flex-col justify-center lg:gap-4 gap-2 items-center p-2">
    @for (filter of filters; track filter) {
    @if (filter === activeFilter) {
    <button class="blue-button" (click)="clearFilter()">{{ filter }}</button>
    } @else {
    <button class="white-button" (click)="applyFilter(filter)">{{ filter }}</button>
    }
    }
</div>

<div class="my-8 overflow-y-auto scrollbar md:h-60 h-48 mr-3">
    @for (question of filteredQuestions; track question;) {
    <details class="group bg-background-dark rounded mb-2 mr-6 ml-6 py-1 px-3">
        <summary class="flex items-center text-blue cursor-pointer list-none">
            <svg class="flex-shrink-0 mr-2" fill="none" height="24" shape-rendering="geometricPrecision"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                viewBox="0 0 24 24" width="20">
                <path d="M6 9l6 6 6-6"></path>
            </svg>

            @for (exam of getExamNames(question); track exam;) {
            <div
                class="max-md:hidden md:visible flex-shrink-0 bg-gray-200 text-gray-700 text-xs font-semibold mr-2 px-2 py-1 rounded">
                {{ exam }}
            </div>
            }

            <span
                class="group-open:invisible md:block flex-grow whitespace-nowrap overflow-hidden text-ellipsis min-w-[25vw] xl:min-w-[15vw] lg:max-w-[40vw] truncate">
                {{ question.value }}
            </span>

            <div class="flex flex-row gap-2 ml-3">
                <ng-icon (click)="handleQuestionSelected(question.id)" class="text-blue opacity-75" size="17"
                    name="faSolidCircleRight"></ng-icon>
            </div>
        </summary>
        <p class="question py-4 px-6 group-open:animate-fadeIn">{{ question?.value }}</p>
    </details>
    }
</div>